import { Injectable } from '@angular/core';
import { Action, State, StateContext, createSelector } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';

import { v4 as uuidv4 } from 'uuid';

import * as actions from './leaderboard.actions';
import { LeaderboardStateModel } from './leaderboard-state.model';
import { LeaderboardAssociationModel } from './leaderboard-association.model';

function getCombinedPuzzleId(payload) {
  //return `${payload.projectId}-${payload.puzzleName}-${payload.puzzleId}`
  return payload.puzzleId;
}

// @dynamic
@State<LeaderboardStateModel>({
  name: 'leaderboardStates',
  defaults: {
    leaderboardEntries: {},
  },
})
@Injectable()
export class LeaderboardState {
  static getByID(puzzleID: string) {
    return createSelector([this], (state: LeaderboardStateModel) => {
      if (state.leaderboardEntries.hasOwnProperty(puzzleID)) {
        return state.leaderboardEntries[puzzleID];
      }
      return null;
    });
  }

  @Action(actions.InitLeaderboardAssociation)
  InitLeaderboardAssociation(
    store: StateContext<LeaderboardStateModel>,
    { payload }: actions.InitLeaderboardAssociation
  ) {
    const key = getCombinedPuzzleId(payload);
    const state = store.getState();
    const newEntry = {
      ...state.leaderboardEntries[key],
      leaderboardUUID: uuidv4(),
      helpersUsed: [],
      startCounter: state.leaderboardEntries[key]?.startCounter ? state.leaderboardEntries[key]?.startCounter + 1 : 1,
      puzzleIsFinished: state.leaderboardEntries[key]?.puzzleIsFinished || false,
      wantLeaderboardRules: payload.wantLeaderboardRules,
    } as LeaderboardAssociationModel;

    store.setState(
      patch({
        leaderboardEntries: patch({
          [key]: newEntry,
        }),
      })
    );
  }

  @Action(actions.UseHelper)
  UseHelper(store: StateContext<LeaderboardStateModel>, { payload }: actions.UseHelper) {
    const key = getCombinedPuzzleId(payload);
    const state = store.getState();
    if (!state.leaderboardEntries[key]) {
      return;
    }
    if (
      state.leaderboardEntries[key].helpersUsed &&
      state.leaderboardEntries[key].helpersUsed.includes(payload.helperUsed)
    ) {
      return;
    }
    store.setState(
      patch({
        leaderboardEntries: patch({
          [key]: patch({
            helpersUsed: [payload.helperUsed, ...(state.leaderboardEntries[key].helpersUsed || [])],
            everUsedHelpers: true,
          }),
        }),
      })
    );
  }

  @Action(actions.SavePostedEntry)
  SavePostedEntry(store: StateContext<LeaderboardStateModel>, { payload }: actions.SavePostedEntry) {
    const key = getCombinedPuzzleId(payload);
    const state = store.getState();
    if (!state.leaderboardEntries[key]) {
      return;
    }
    store.setState(
      patch({
        leaderboardEntries: patch({
          [key]: patch({
            submittedEntry: payload.submittedEntry,
            submittedEntryUUID: payload.submittedEntryUUID,
          }),
        }),
      })
    );
  }

  @Action(actions.SetFinished)
  SetFinished(store: StateContext<LeaderboardStateModel>, { payload }: actions.SetFinished) {
    const key = getCombinedPuzzleId(payload);
    const state = store.getState();
    if (!state.leaderboardEntries[key]) {
      return;
    }
    store.setState(
      patch({
        leaderboardEntries: patch({
          [key]: patch({
            puzzleIsFinished: true,
          }),
        }),
      })
    );
  }
}
